module.exports = __webpack_public_path__ + "img/Juniper-SRX.8fc4386.svg";